// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__26N3o","title":"styles_title__3RI8N"};